export const APP_BASE_URL = '';
export const ROUTER_URL = 'https://console.ibzbot.com';

export const SHOW_FAQS = true;

export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'success',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
  FAQ_SECTION: -1,
};

export const WOOT_PREFIX = 'chatwoot-widget:';
